import MobileDetect from 'mobile-detect';

export const preloadImg = (url) => {
  const img = new Image();
  img.src = url;
};

export const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const getYTId = (url) => {
  let videoId = url.split('v=')[1];
  if (!videoId) {
    return '';
  }
  const ampersandPosition = videoId.indexOf('&');
  if (ampersandPosition !== -1) {
    videoId = videoId.substring(0, ampersandPosition);
  }

  return videoId;
};

export const filterVisibleSections = (caseItem, mapOfSections) =>
  caseItem &&
  caseItem.filter(section => section && mapOfSections[section.type]);

export const removeAnimationContainer = () => {
  const animationContainer = document.getElementById('animation_container');
  animationContainer && animationContainer.remove();
};

export const getMobileAgent = (req) => {
  const md = new MobileDetect(req.headers['user-agent']);
  return md.mobile();
};



// WEBPACK FOOTER //
// ./src/helpers/index.js